import { Backdrop, CircularProgress } from "@mui/material";
import { getAppTheme } from "../../config/resolve-app-brand";
import { useTheme } from "../../context/ThemeContext";

const BackdropLoading = ({ open }) => {
  const { isDarkMode } = useTheme();

  const theme = getAppTheme(isDarkMode);

  return (
    <Backdrop
      sx={{ color: theme.palette.primary.main, zIndex: 9999999999999 }}
      open={open}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default BackdropLoading;
